import { render, staticRenderFns } from "./TrainingRegistrationHeader.vue?vue&type=template&id=8af55370&scoped=true&"
import script from "./TrainingRegistrationHeader.vue?vue&type=script&lang=js&"
export * from "./TrainingRegistrationHeader.vue?vue&type=script&lang=js&"
import style0 from "./TrainingRegistrationHeader.vue?vue&type=style&index=0&id=8af55370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af55370",
  null
  
)

export default component.exports